<template>
  <div>
    <transition appear @before-enter="$animations.beforeEnterLogoArea" @enter="$animations.enterLogoArea">
      <Logo></Logo>
    </transition>
    <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
      <div class="columns mb-0 is-centered">
        <div v-if="$root.selectedLanguage === `en`" class="column" style="text-align: center">
          <img src="../assets/images/icons/RDBheaderimages/Group 289344.png" alt="contact-img" width="85%" />
        </div>
        <div v-if="$root.selectedLanguage === `si`" class="column" style="text-align: center">
          <img src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37572.png" alt="contact-img" width="70%" />
        </div>
      </div>
    </transition>
    <div class="card px-3 py-5  " style="width: 80%; margin: 0 auto 80px auto; ">
      <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
        <div class="columns is-centered">
          <div class="column is-full ps-5" style="text-align: center">
            <img src="../assets/images/icons/Blue/Frame 37763.png" alt="contact-info-img" width="70" height="70" />
            <p :class="`text-center mx-3 mb-2 ${$root.selectedLanguage === `ta`
              ? `ta-he-line`
              : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
              }`">
              {{ $root.selectedLanguageData.businessInfo }}
            </p>
            <p :class="`${$root.selectedLanguage === `ta`
              ? `ta-sub-line`
              : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
              }`">
              {{ $root.selectedLanguageData.tellUsMoreAboutYourBusinessOrEmployment }}
            </p>
            <p>
              {{ $root.selectedLanguageData.fill_the_below_form }}
            </p>
          </div>
        </div>
      </transition>
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="">
          <div class="columns is-7 is-centered">
            <div class="column is-three-quarters pt-5 ps-5">

              <!--              occupation start here-->

              <div >
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                  {{ $root.selectedLanguageData.occupation }}
                  <span class="has-text-danger">*</span>
                </label>
                <ValidationProvider name="occupation" :rules="{ required: true }" v-slot="{ errors }">
                  <div>
                    <b-select
                        @focus="$inputFocused('employment_position')"
                        @input="()=>{$inputChanged('employment_position'); if($root.formData.employment_position !== 'Other'){
                          $root.formData.employment_position_specify = ''
                        }}"
                        @blur="$inputBlured('employment_position')"
                        v-model="$root.formData.employment_position" expanded>
                      <option v-for="o in $root.selectedLanguageData.occupations" :value="o" :key="o">
                        {{ o }}
                      </option>
<!--                      <option value="Other">-->
<!--                        {{ $root.selectedLanguageData.other }}-->
<!--                      </option>-->
                    </b-select>
                  </div>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!--              if occupation is other this section will active-->

              <div class="mt-4"  v-if="$root.formData.employment_position === 'Other'">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                  {{ $root.selectedLanguageData.specify_the_occupation }}
                  <span class="has-text-danger">*</span>
                </label>
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider name="occupation" :rules="employeerName()" v-slot="{ errors }">
                      <b-input type="text"

                               v-model="$root.formData.employment_position_specify"
                               @focus="$inputFocused('employment_position_specify')"
                               @input="() => {$inputChanged('employment_position_specify');}"
                               @blur="$inputBlured('employment_position_specify')"/>


                      <span class="icon is-small is-right mr-2">
                      <img
                          src="../assets/images/icons/Blue/Edit.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                      />
                    </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>

                  </p>
                </b-field>
              </div>

<!--              Name of employer-->
              <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                  {{ $root.selectedLanguageData.nameofEmployerBusiness }}
                  <span class="has-text-danger">*</span>
                </label>

                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider name="Employer/Business Name" :rules="employeerName()" v-slot="{ errors }">

                      <b-input type="text"
                               v-model="$root.formData.employer_name"
                               @focus="$inputFocused('employer_name')"
                               @blur="$inputBlured('employer_name')"/>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                      <span class="icon is-small is-right mr-2">
                      <img
                          src="../assets/images/icons/Blue/Group 156.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                      />
                    </span>

                  </p>
                </b-field>

              </div>
<!--employer address-->
              <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                  {{ $root.selectedLanguageData.employerBusinessAddress }}
                  <span class="has-text-danger">*</span>
                </label>
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider
                        name="Employer Address"
                        :rules="addressValidator()"
                        v-slot="{ errors }">
                      <b-input v-model="$root.formData.employer_addr" maxlength="200" type="textarea"></b-input>
                      <span class="icon is-small is-right mr-2">
                      <img
                          src="../assets/images/icons/Blue/Location.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                      />
                    </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div>

              <div class="mt-4 columns  ">
                <div
                    class="column is-7 is-offset-5 is-flex is-flex-direction-row-reverse"
                >
                  <b-button
                      :disabled="invalid"
                      @click="submitForm();"
                      :class="`is-primary  ${
                  $root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`"
                  >

                    <!-- :disabled="invalid || userCode !== $root.formData.countryCode" -->

                    {{ $root.selectedLanguageData.continue }}
                  </b-button>
                  <b-button
                      @click="$router.go(-1)"
                      :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`"

                  >{{ $root.selectedLanguageData.back }}
                  </b-button>
                </div>
              </div>




            </div>
          </div>

        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Logo from "./NsbKycLogo.vue"

export default {

  components: {
    Logo,
    ValidationObserver,
    ValidationProvider
  },

  methods:{
    submitForm: function () {
      var comp = this;


      var bodyFormData = new FormData();

      bodyFormData.append("kyc_branch", comp.$root.formData.branch);


      let identificationType = "old-nic";
      if (comp.$root.formData.idType === "ONIC") {
        identificationType = "old-nic";
      } else if (comp.$root.formData.idType === "NNIC") {
        identificationType = "new-nic";
      } else if (comp.$root.formData.idType === "PNO") {
        identificationType = "passport";
      }

      // let publicPositionsHeldBySelf = "No";
      // if (
      //   comp.$root.formData.politically_exposed ==
      //   "public Positions Held BySelf"
      // ) {
      //   publicPositionsHeldBySelf = "Yes";
      // } else {
      //   publicPositionsHeldBySelf = "No";
      // }

      bodyFormData.append("account_type", comp.$root.formData.account_type);
      bodyFormData.append("currency_type", comp.$root.formData.currency_type); // new field to add currency type
      bodyFormData.append(
          "currency_type_code",
          comp.$root.formData.currency_type_code
      ); // new field to add currency type code

      bodyFormData.append("contact_no", comp.$root.formData.mobileNumber);
      bodyFormData.append(
          "contact_no_work",
          comp.$root.formData.officeNumber
      );
      bodyFormData.append(
          "contact_no_resident",
          comp.$root.formData.residentNumber
      );
      bodyFormData.append("email", comp.$root.formData.email);
      bodyFormData.append("title", comp.$root.formData.title);

      bodyFormData.append("name_with_init", comp.$root.formData.name_with_init);
      bodyFormData.append("full_name", comp.$root.formData.full_name);
      bodyFormData.append("nic_type", identificationType);
      bodyFormData.append("customer_nic", comp.$root.formData.customer_nic); // done - adjust the above if else


      bodyFormData.append("gender", comp.$root.formData.gender);



      bodyFormData.append("date_of_birth",comp.formatDate(comp.$root.formData.date_of_birth));

      bodyFormData.append("marital_status", comp.$root.formData.marital_status);
      bodyFormData.append("spouse_name", comp.$root.formData.spouse_name); // todo :: consider - no field is added yet


      bodyFormData.append("citizenship", comp.$root.formData.citizenship);
      bodyFormData.append("residentship", comp.$root.formData.residentship);
      bodyFormData.append("politically_exposed", comp.$root.formData.politically_exposed);
      //console.log("politically_exposed-----> "+comp.$root.formData.politically_exposed)
      bodyFormData.append("politically_exposed_position", comp.$root.formData.politically_exposed_position);
      //console.log("politically_exposed_position-----> "+comp.$root.formData.politically_exposed_position)

      bodyFormData.append(
          "politically_exposed_relative",
          comp.$root.formData.politically_exposed_relative
      );
      bodyFormData.append(
          "politically_exposed_relative_position",
          comp.$root.formData.politically_exposed_relative_position
      );



      // bodyFormData.append("nature_of_business",comp.$root.formData.natureOfEmployment);
      bodyFormData.append('occupation',comp.$root.formData.occupation);
      bodyFormData.append(
          "employment_position",
          comp.$root.formData.employment_position
      );
      bodyFormData.append(
          "employment_position_specify",
          comp.$root.formData.employment_position_specify
      );

      bodyFormData.append(
          "employment_position_spouse",
          comp.$root.formData.employment_position_spouse
      ); // todo :: no field is added yet
      bodyFormData.append("employer_name", comp.$root.formData.employer_name);
      bodyFormData.append(
          "employer_name_spouse",
          comp.$root.formData.employer_name_spouse
      ); // todo :: no field is added yet
      bodyFormData.append("employer_addr", comp.$root.formData.employer_addr);
      bodyFormData.append(
          "purpose_of_opening",
          comp.$root.formData.purpose_of_opening.value
          // comp.getValuesSeperatedWithCommas(

          // )
      );
      bodyFormData.append(
          "source_of_income",
          comp.$root.formData.source_of_income
      );
      //console.log("source_of_income-----> "+comp.$root.formData.source_of_income)

      bodyFormData.append(
          "source_of_income_specify",
          comp.$root.formData.other_source_of_income
      );
      //console.log("source_of_income_specify-----> "+comp.$root.formData.other_source_of_income)

      bodyFormData.append(
          "income_details",
          comp.$root.formData.income_details
      );
      bodyFormData.append(
          "anticipated_vol",
          comp.$root.formData.anticipated_vol.value
      );
      bodyFormData.append(
          "expected_delivery_channel",
          comp.$root.formData.expected_delivery_channel.value
      );
      bodyFormData.append(
          "other_businesses",
          comp.$root.formData.other_businesses
      );


      // newly added fields start ----------------------------------------------------------------------------

      //account select page
      bodyFormData.append("preferred_branch", comp.$root.formData.branch);
      // bodyFormData.append("account_type", comp.$root.formData.account_type);
      bodyFormData.append("account", comp.$root.formData.account);
      bodyFormData.append("time_period", comp.$root.formData.account_time_period);
      bodyFormData.append("selected_account", comp.$root.formData.account_name);

      //personal information page
      bodyFormData.append("residentship_country", comp.$root.formData.resident_country);
      bodyFormData.append("driving_licence", comp.$root.formData.account_holder_driving_licence);
      bodyFormData.append("customer_passport_no", comp.$root.formData.account_holder_passport_number);
      //console.log("passport_no-----> "+comp.$root.formData.account_holder_passport_number);
      bodyFormData.append("passport_issue_date", comp.$root.formData.account_holder_passport_issue_date);
      //console.log("passport_issue_date-----> "+comp.$root.formData.account_holder_passport_issue_date);
      bodyFormData.append("passport_expiry_date", comp.$root.formData.account_holder_passport_expiry_date);
      //console.log("passport_expiry_date-----> "+comp.$root.formData.account_holder_passport_expiry_date);
      bodyFormData.append("tax_payer", comp.$root.formData.tax_payer);
      bodyFormData.append("tax_file_number", comp.$root.formData.tax_file_number);

      //purpose page
      // bodyFormData.append("purpose_of_opening_usage", comp.$root.formData.purpose_of_opening);
      bodyFormData.append("purpose_of_opening_usage_specify", comp.$root.formData.other_purpose_of_opening);

      bodyFormData.append("source_of_funds", comp.$root.formData.source_of_fund);
      //console.log("source of funds-----> "+ comp.$root.formData.source_of_fund)

      bodyFormData.append("source_of_funds_specify", comp.$root.formData.other_source_of_fund);
      //console.log("source_of_funds_specify-----> "+ comp.$root.formData.other_source_of_fund)

      bodyFormData.append("expected_turnover", comp.$root.formData.expected_turnover.value);
      bodyFormData.append("expected_mode_of_transaction", comp.$root.formData.expected_mode_of_transaction);
      bodyFormData.append("expected_mode_of_transaction_specify", comp.$root.formData.other_expected_mode_of_transaction);
      // bodyFormData.append("")
      bodyFormData.append("asset_residential_property", comp.$root.formData.asset_residential_property);
      bodyFormData.append("asset_financial", comp.$root.formData.asset_financial);
      bodyFormData.append("asset_motor_vehicles", comp.$root.formData.asset_motor_vehicles);
      bodyFormData.append("asset_land_buildings", comp.$root.formData.asset_land_buildings);
      bodyFormData.append("asset_investments_shares", comp.$root.formData.asset_investments_shares);
      bodyFormData.append("asset_other", comp.$root.formData.asset_other);

      bodyFormData.append("asset_specify", comp.$root.formData.other_assets_held);

      bodyFormData.append("asset_residential_property_value", comp.$root.formData.asset_residential_property_value);
      bodyFormData.append("asset_investments_shares_value", comp.$root.formData.asset_investments_shares_value);
      bodyFormData.append("asset_land_buildings_value", comp.$root.formData.asset_land_buildings_value);
      bodyFormData.append("asset_motor_vehicles_value", comp.$root.formData.asset_motor_vehicles_value);
      bodyFormData.append("asset_financial_value", comp.$root.formData.asset_financial_value);
      bodyFormData.append("asset_other_value", comp.$root.formData.asset_other_value);


      //vas page
      bodyFormData.append("vas_sms_alerts", comp.$root.formData.sms_service);
      bodyFormData.append("vas_internet_banking", comp.$root.formData.e_banking_service);
      bodyFormData.append("vas_virtual_wallet", comp.$root.formData.virtual_wallet_service);
      bodyFormData.append("vas_estatement", comp.$root.formData.estatement_service);
      bodyFormData.append("vas_debit_card", comp.$root.formData.debit_card_service);
      bodyFormData.append("vas_pos_required", comp.$root.formData.pos_required);
      bodyFormData.append("vas_acc_linked_pos_transaction", comp.$root.formData.account_to_be_linked);
      bodyFormData.append("vas_card_delivery_details", comp.$root.formData.card_delivery);
      bodyFormData.append("vas_pin_delivery_details", comp.$root.formData.card_pin_delivery);
      bodyFormData.append("vas_card_type", comp.$root.formData.facility_debit_card_type);
      bodyFormData.append("mother_maiden_name", comp.$root.formData.mother_maiden_name);

      //document page
      bodyFormData.append("birth_certificate_front_image", comp.$root.productImages.birth_certificate_front_image);
      bodyFormData.append("birth_certificate_back_image", comp.$root.productImages.birth_certificate_back_image);
      bodyFormData.append("passport_bio_page_image", comp.$root.productImages.passport_bio_page_image);
      bodyFormData.append("passport_alterations_page_image", comp.$root.productImages.passport_alteration_page_image);
      bodyFormData.append("passport_entry_stamp_page_image", comp.$root.productImages.passport_entry_stamp_page_image);
      bodyFormData.append("driving_licence_image", comp.$root.productImages.driving_licence_image);

      //us person perment and mailing address
      bodyFormData.append("us_person_permanent_address_line1", comp.$root.formData.us_person_permanent_address_line1);
      bodyFormData.append("us_person_permanent_address_line2", comp.$root.formData.us_person_permanent_address_line2);
      bodyFormData.append("us_person_permanent_address_line3", comp.$root.formData.us_person_permanent_address_line3);
      bodyFormData.append("us_person_permanent_address_postal_code", comp.$root.formData.us_person_permanent_address_postal_code);
      bodyFormData.append("us_person_permanent_address_country", comp.$root.formData.us_person_permanent_address_country);
      bodyFormData.append("us_person_mailing_address_line1", comp.$root.formData.us_person_mailing_address_line1);
      bodyFormData.append("us_person_mailing_address_line2", comp.$root.formData.us_person_mailing_address_line2);
      bodyFormData.append("us_person_mailing_address_line3", comp.$root.formData.us_person_mailing_address_line3);
      bodyFormData.append("us_person_mailing_address_postal_code", comp.$root.formData.us_person_mailing_address_postal_code);
      bodyFormData.append("us_person_mailing_address_country", comp.$root.formData.us_person_mailing_address_country);



      // bodyFormData.append("")
      // bodyFormData.append("", comp.$root.formData.us_person);

      bodyFormData.append("us_person", comp.$root.formData.us_person);
      bodyFormData.append("mailing_address_in_us_same_as_permanent_address", comp.$root.formData.mailing_address_in_us_same_as_permanent_address_in_us);


      bodyFormData.append(
          "us_person_account_numbers",
          comp.$root.formData.us_person_account_numbers
      );
      bodyFormData.append(
          "us_person_place_of_birth",
          comp.$root.formData.us_person_place_of_birth
      );
      bodyFormData.append(
          "us_person_permanent_address",
          comp.$root.formData.us_person_permanent_address
      );
      bodyFormData.append(
          "us_person_correspondent_address",
          comp.$root.formData.us_person_correspondent_address
      );
      bodyFormData.append(
          "us_person_passport_no",
          comp.$root.formData.us_person_passport_no
      );
      bodyFormData.append(
          "us_person_telephone_no",
          comp.$root.formData.us_person_telephone_no
      );

      if (
          comp.$root.formData.citizenship === "Sri Lankan with Dual Citizenship"
      ) {
        bodyFormData.append(
            "dual_citizen_countries",
            comp.$root.formData.dual_citizen_countries
        );
      } else if (
          comp.$root.formData.citizenship ===
          "Foreign National with Dual Citizenship"
      ) {
        bodyFormData.append(
            "dual_citizen_countries",
            comp.$root.formData.dual_citizen_countries.toString()
        );
      }

      bodyFormData.append(
          "us_person_tax_identification_no",
          comp.$root.formData.us_person_tax_identification_no
      );
      bodyFormData.append(
          "facility_internet_banking",
          comp.$root.formData.facility_internet_banking
      );
      bodyFormData.append(
          "facility_debit_card",
          comp.$root.formData.facility_debit_card
      );
      bodyFormData.append(
          "facility_debit_card_type",
          comp.$root.formData.facility_debit_card_type
      );
      bodyFormData.append(
          "vas_visa_card_name",
          comp.$root.formData.facility_debit_card_customer_name
      );

      bodyFormData.append(
          "foreign_national_country",
          comp.$root.formData.foreign_national_country
      );
      bodyFormData.append(
          "resident_countries",
          JSON.stringify(comp.$root.formData.resident_countries)
      );
      bodyFormData.append(
          "visa_proof_doc",
          comp.$root.productImages.visa_proof_doc
      );




      // bodyFormData.append("indemnity", indemnity);
      bodyFormData.append(
          "locationAccess",
          comp.$root.formData.nicNumberAllowToLocationServicesInYourBrowser
      );
      bodyFormData.append(
          "nicVerificationDRP",
          comp.$root.formData.nicNumberAllowToDRP
      );

      // bodyFormData.append('keystroke_dynamics', JSON.stringify(comp.$root.keyStrokeDynamics));
      bodyFormData.append(
          "keystroke_dynamics",
          JSON.stringify(comp.$root.keyStrokeDynamics)
      ); // this was added - used in other branches
      // bodyFormData.append("keystroke_dynamics",JSON.stringify(comp.$root.keyStrokeStatics)); // this was added

      bodyFormData.append(
          "face_ids",
          JSON.stringify(comp.$root.formData.face_ids)
      ); //added

      bodyFormData.append(
          "location_details",
          JSON.stringify(comp.$root.formData.location_details)
      );

      var language = "en";
      if (comp.$root.selectedLanguage == "en") {
        language = "english";
      } else if (comp.$root.selectedLanguage == "ta") {
        language = "tamil";
      } else {
        language = "sinhala";
      }

      bodyFormData.append("preferred_language", language);
      bodyFormData.append("introduced_by", comp.$root.formData.introduced_by);

      bodyFormData.append(
          "nic_front_image",
          comp.$root.productImages.nic_front_image
      );
      bodyFormData.append(
          "nic_back_image",
          comp.$root.productImages.nic_back_image
      );
      bodyFormData.append(
          "selfie_image",
          comp.$root.productImages.selfie_image
      );
      bodyFormData.append("sign_image", comp.$root.productImages.sign_image);
      bodyFormData.append(
          "addr_proof_doc",
          comp.$root.productImages.addr_proof_doc
      );



      // new modification - 2022-9-22 - new field adding ---------------------------------------------------------------
      bodyFormData.append(
          "passport_image",
          comp.$root.productImages.passport_image
      );
      bodyFormData.append(
          "customer_passport_no",
          comp.$root.formData.account_holder_passport_number.toUpperCase()
      );

      bodyFormData.append("customer_preferred_time", comp.$root.formData.videoCallTimeSlot);
      bodyFormData.append("customer_preferred_date", comp.$root.formData.videoCallDate);


      // permanent address
      bodyFormData.append(
          "permanent_address_line1",
          comp.$root.formData.permanent_address_line1
      );
      bodyFormData.append(
          "permanent_address_line2",
          comp.$root.formData.permanent_address_line2
      );
      bodyFormData.append(
          "permanent_address_line3",
          comp.$root.formData.permanent_address_line3
      );
      bodyFormData.append(
          "permanent_address_postal_code",
          comp.$root.formData.permanent_address_postal_code
      );
      bodyFormData.append(
          "permanent_address_country",
          comp.$root.formData.permanent_address_country
      );

      bodyFormData.append(
          "mailing_address_same_as_permanent_address",
          comp.$root.formData.mailing_address_same_as_permanent_address
      );

      // mailing address
      bodyFormData.append(
          "mailing_address_line1",
          comp.$root.formData.mailing_address_line1
      );
      bodyFormData.append(
          "mailing_address_line2",
          comp.$root.formData.mailing_address_line2
      );
      bodyFormData.append(
          "mailing_address_line3",
          comp.$root.formData.mailing_address_line3
      );
      bodyFormData.append(
          "mailing_address_postal_code",
          comp.$root.formData.mailing_address_postal_code
      );
      bodyFormData.append(
          "mailing_address_country",
          comp.$root.formData.mailing_address_country
      );

      // foreign address
      bodyFormData.append(
          "foreign_address_line1",
          comp.$root.formData.foreign_address_line1
      );
      bodyFormData.append(
          "foreign_address_line2",
          comp.$root.formData.foreign_address_line2
      );
      bodyFormData.append(
          "foreign_address_line3",
          comp.$root.formData.foreign_address_line3
      );
      bodyFormData.append(
          "foreign_address_postal_code",
          comp.$root.formData.foreign_address_postal_code
      );
      bodyFormData.append(
          "foreign_address_country",
          comp.$root.formData.foreign_address_country
      );

      // us-person correspondent address
      bodyFormData.append(
          "correspondent_address_line1",
          comp.$root.formData.correspondent_address_line1
      );
      bodyFormData.append(
          "correspondent_address_line2",
          comp.$root.formData.correspondent_address_line2
      );
      bodyFormData.append(
          "correspondent_address_line3",
          comp.$root.formData.correspondent_address_line3
      );
      bodyFormData.append(
          "correspondent_address_postal_code",
          comp.$root.formData.correspondent_address_postal_code
      );
      bodyFormData.append(
          "correspondent_address_country",
          comp.$root.formData.correspondent_address_country
      );

      bodyFormData.append("surname", comp.$root.formData.surname);
      bodyFormData.append("other_name", comp.$root.formData.other_name);
      let kyc_token = comp.$root.formData.kyc_token +'.'+ comp.$root.formData.color_code4 +'.'+ comp.$root.formData.color_code12;

      comp.$http
          .post(comp.$baseURL + "/kycForm/submitAccountInfoKycForm", bodyFormData, {
            headers: { "Content-Type": "multipart/form-data","X-token":kyc_token },
          })
          .then(function (response) {
            //handle success
            console.log("kyc token....",kyc_token)
            console.log("successfully submitted--------------");
            console.log(response);

            comp.isContinueButtonLoading = false;
            comp.$root.isFormSubmitted = true;
            comp.$router.push('VasInfo')

            /* comp.$router.push("congratulation");*/
          })
          .catch(function (response) {
            //handle error
            console.log(response);
            comp.$buefy.toast.open({
              message: "Failed to submit form data",
              type: "is-danger",
            });
          });
    },
    formatDate(date){
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate()

      if(month < 10){
        month = "0"+month;
      }
      let output = [month,day,year]
      return output.join("/")
    },
    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        this.$http
          .post(this.$baseURL + "/kycForm/updateLastStep", {
            last_step_name:'Purpose Info',
            last_step: 4,
            form_filled:true,
            next_route:'Employment Info',
          },{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          }).catch((response) => {
            this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
            });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },

    employeerName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
        // includes: " ",
        noNumbers: true
      };
      return obj;
    },

    addressValidator : function () {
      const obj = {
        required: true,
        notStartsWith: " ",
        notEndsWith: " "
      }
      return obj;
    },

    calDebitCardName() {
      if (this.$root.formData.facility_debit_card_customer_name === ``)
        this.$root.formData.facility_debit_card_customer_name =
            this.$root.formData.other_name.slice(0, 1).toUpperCase() +
            " " +
            this.$root.formData.surname.toUpperCase();
    },

  },

  mounted() {
    this.updateLastStep();
    this.calDebitCardName()
  }


}
</script>